export default "__VITE_ASSET__Dtf50$ZQ__"